<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/purchase/orders">{{ $t('purchase_order_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('sale_order_preview') }}</li>
        </ol>
    <div class="x_header">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t('back') }}</button>
        <template v-if="header.Status=='Draft'">
            <router-link :to="{ name: 'purchase_order_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-pencil"></i> {{$t('edit')}}</router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onApproval"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
        </template>
        <template v-if="header.Status!='Draft' && header.StockStatus!='Done'">
            <router-link :to="{ name: 'purchase_order_stock', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-car"></i> {{$t('request_stock_in')}}</router-link>
        </template>
        <template v-if="header.Status=='Nothing To Invoice'">
            <router-link :to="{ name: 'purchase_order_invoice_create', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus"></i> {{$t('purchase_order_invoice_create')}}</router-link>
        </template>
    </div>
    <div class="x_body">
        <div class="card f_card">
            <div class="card-body">
                <h3 class="text-center" style="font-weight: bold;">{{$t('purchase_order_list')}}</h3>
                <div class="row">
                    <div class="col-sm-6">
                        <table class="table-print">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{ $t('vendor') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{header.PartnerName}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 100px;">{{ $t('phone') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{header.Phone}}</td>
                                </tr>
                                <tr>
                                    <td style="width: 100px;">{{ $t('ship_to') }}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{header.BranchName}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-sm-6">
                        <table class="table-print" align="right">
                            <tbody>
                                <tr>
                                    <td style="width: 100px;">{{$t('code')}}</td>
                                    <td style="width: 15px;">:</td>
                                    <td>{{header.Num}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('date')}}</td>
                                    <td>:</td>
                                    <td>{{$format(header.Date, 'DD/MM/YYYY')}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-bordered table-sm no-bor">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                    <th>{{$t('item_name')}}</th>
                                    <th>{{$t('description')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('qty')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('stock_in')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('uom')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('unit_price')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('tax_line')}}(%)</th>
                                    <th class="text-right" style="width: 100px;">{{$t('sub_total')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td>{{ret.Description}}</td>
                                    <td class="text-center">{{ret.Quantity}}</td>
                                    <td class="text-center">{{ret.ReceiveQty}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td class="text-right">{{$dollar(ret.Price)}}</td>
                                    <td class="text-right">{{$dollar(ret.TaxLine)}}</td>
                                    <td class="text-right">{{$dollar(ret.SubTotal)}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="8" class="text-right">{{$t('untax_amount')}}</th>
                                    <th class="text-right">{{$dollar(header.GrandTotal)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="8" class="text-right">{{$t('total')}}</th>
                                    <th class="text-right">{{$dollar(header.PaidAmount)}}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <br>
                <div class="row" v-if="list.length > 0">
                    <div class="col-sm-12">
                        <div class="blue x-title font-m"><i class="fa fa-car" aria-hidden="true"></i> {{$t('stock_in')}}</div>
                        <table class="table table-bordered table-striped table-sm no-bor">
                            <thead>
                            <tr>
                                <th style="width: 80px;" class="text-center">{{ $t('no') }}</th>
                                <th>{{ $t('stock_in_no') }}</th>
                                <th>{{ $t('date') }}</th>
                                <th>{{ $t('type') }}</th>
                                <th>{{ $t('ref_num') }}</th>
                                <th>{{$t('branch_name')}}</th>
                                <th>{{$t('receiver') }}</th>
                                <th style="width: 80px;">{{$t('status')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td class="text-center">{{ index+1 }}</td>
                                <td><router-link :to="{ name: 'stock_in_preview', params: { id: ret.Id }}">{{ ret.Num }}</router-link></td>
                                <td>{{ $format(ret.InDateAt, 'DD-MM-YYYY') }}</td>
                                <td>{{ret.DocSource}}</td>
                                <td>{{ret.DocSourceNo}}</td>
                                <td>{{ ret.BranchName }}</td>
                                <td>{{ ret.EmployeeName }}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br>
                <div class="row" v-if="invoice.length > 0">
                    <div class="col-sm-12">
                        <div class="blue x-title font-m"><i class="fa fa-usd" aria-hidden="true"></i> {{$t('purchase_invoice')}}</div>
                        <table class="table table-bordered table-striped table-sm no-bor">
                            <thead>
                            <tr>
                                <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                                <th>{{$t('invoice_no')}}</th>
                                <th>{{$t('date')}}</th>
                                <th>{{$t('due_date')}}</th>
                                <th>{{$t('vendor')}}</th>
                                <th>{{$t('type')}}</th>
                                <th>{{$t('ref_num')}}</th>
                                <th class="text-right" style="width: 110px;">{{$t('amount')}}</th>
                                <th class="text-right" style="width: 110px;">{{$t('discount')}}</th>
                                <th class="text-right" style="width: 110px;">{{$t('pay_amount')}}</th>
                                <th class="text-right" style="width: 110px;">{{$t('balance')}}</th>
                                <th style="width: 80px;">{{$t('status')}}</th>
                                <th style="width: 110px;">{{$t('payment_status')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(ret, index) in invoice" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td>
                                    <router-link :to="{name: 'po_invoice_view', params: {id: ret.Id}}">{{ret.Num}}</router-link>
                                </td>
                                <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                                <td>{{$format(ret.DueDate, 'DD/MM/YYYY')}}</td>
                                <td>{{ret.VendorName}}</td>
                                <td>{{ret.DocSource}}</td>
                                <td>{{ret.DocSourceNo}}</td>
                                <td class="text-right">{{$money(ret.GrandTotal)}}</td>
                                <td class="text-right">{{$money(ret.Discount)}}</td>
                                <td class="text-right">{{$money(ret.PaidAmount)}}</td>
                                <td class="text-right">{{$money(ret.Balance)}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                                <td class="cell-badge" v-html="$statusLabel(ret.PaidStatus)"></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <br>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        data: function(){
            return {
                header: {
                    Status: '',
                    StockStatus: 'Pending'
                },
                lines: [],
                query:{
                    Text: '',
                    FromDate: '',
                    ToDate: '',
                    Page: 1,
                    Total: 0,
                    Limit: 25
                },
                list: [],
                invoice: []
            }
        },
        created: function(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                let loading = this.$loading.show();
                this.$api().post('purchase/order/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        let data = res.data.Json;
                        this.header = data.Header;
                        this.lines = data.Lines;
                    }
                }).finally(function(){ loading.hide(); });
            }
            this.$api().post('purchase/order/stockin', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    this.list = res.data.Data;
                    this.query.Total = res.data.Total;
                }
            });
            this.$api().post('purchase/order/invoices', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    this.invoice = res.data.Data;
                    this.query.Total = res.data.Total;
                }
            });
        },
        methods: {
            onApproval(){
                let id = this.$route.params.id;
                let loading = this.$loading.show();
                this.$api().post('purchase/order/approval', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/purchase/orders');
                    }
                }).finally(function(){ loading.hide(); });
            }
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
    .none-left{
        border-left: none;
    }
    .none-bottom{
        border-bottom: none;
        border-top: none;
    }
</style>
